<template>
  <section>
    <div class="advantage-header">
      <p class="do-you-want-buy-text">
        <span class="mobile-br">想在1688買東西，<br />卻困難重重嗎？</span>
        <span class="desktop-text">想在1688買東西，<br />卻困難重重嗎？</span>
      </p>
      <picture>
        <source
          media="(min-width: 1060px)"
          srcset="@/assets/images/desktop/advantage/Group_3860.svg"
        />
        <img
          class="advantage-img-1"
          src="@/assets/images/mobile/advantage/Group_3916.svg"
        />
      </picture>
    </div>

    <div class="trouble-section">
      <div class="bl-bg1-Trouble">
        <img
          class="back-blue-desktop"
          src="@/assets/images/desktop/advantage/Group_3861.svg"
        />
        <p class="blue-text">
          這些煩惱<br />
          讓1688專業代買
          <span style="color: #99f9f9; padding-left: 5px; padding-right: 5px"
            >CHATxBUY</span
          >
          <br class="mobile-only" />
          通通幫你搞定！
        </p>
        <div class="bl-ellipse-Trouble-mo"></div>
        <img class="plant" src="@/assets/images/desktop/advantage/plant.svg" />
      </div>
    </div>
  </section>
</template>

<style scoped>
/* Advantage Section */
.advantage-header {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 20px;
}

.do-you-want-buy-text {
  text-align: center;
  font-size: 20px;
  margin-top: 65px;
}

.desktop-text {
  display: none;
}

.advantage-img-1 {
  padding-bottom: 41px;
}

.trouble-section {
  position: relative;
}

.bl-bg1-Trouble {
  background: #5974ff;
  position: relative;
}

.back-blue-desktop {
  display: none;
}

.blue-text {
  color: #ffffff;
  font-size: 20px;
  position: relative;
  top: 30%;
  text-align: center;
  padding-top: 43px;
  z-index: 2;
}

.bl-ellipse-Trouble-mo {
  width: 100%;
  height: 100px;
  background-color: #5974ff;
  border-radius: 50%;
  position: absolute;
  top: 81px;
  z-index: 1;
}

.plant {
  display: none;
}

.mobile-br {
  display: inline;
}

.mobile-only {
  display: inline;
}

@media (min-width: 1060px) {
  .do-you-want-buy-text {
    font-size: 32px;
    margin-top: 121px;
  }

  .mobile-br {
    display: none;
  }

  .desktop-text {
    display: inline;
  }

  .mobile-only {
    display: none;
  }

  .advantage-img-1 {
    padding-bottom: 0px;
  }

  .back-blue-desktop {
    display: block;
    width: 100%;
    height: auto;
    position: relative;
  }

  .blue-text {
    font-size: clamp(26px, 2.22vw, 32px);
    left: 50%;
    top: 30%;
    transform: translateX(-50%);
    position: absolute;
    white-space: nowrap;
    height: auto;
  }

  .bl-bg1-Trouble {
    background: transparent;
  }

  .bl-ellipse-Trouble-mo {
    display: none;
  }

  .plant {
    display: block;
    height: auto;
    position: absolute;
    left: 9%;
    transform: translateY(-100%);
  }
}
</style>
